module.exports = __webpack_public_path__ + "img/732.15500dfa.png";